module.exports = __webpack_public_path__ + "media/images/sp/stores/kamakura/kamakura_concept_02-cf09a76073db8e266fc1b073e64b397f.jpg";